'use strict';

import { Glide, Controls, Swipe, Breakpoints, Images, Keyboard } from './components/carousel'
let isIpad = require('./utilities/clientSideUtil').isIpad;

/**
 * Creates carousel bullet items
 * @param {jQuery} $parentEl container element
 */
function createControls($parentEl) {
    const $carouselItems = $($parentEl).find('.glide__slide').not('.glide__slide--clone');
    let $carouselBullets = $($parentEl).find('[data-glide-el="controls[nav]"]');
    $carouselItems.each(function (index) {
        var $newIndiator = $(`<button class="glide__bullet" data-glide-dir="=${index}" aria-label="Slide ${index + 1}"></button>`);
        $carouselBullets.append($newIndiator);
    });
    $carouselBullets.removeClass('d-none');
}

/**
 * Gets all next siblings of a given DOM element.
 *
 * @param {Element} el - The DOM element to find the next siblings of.
 * @returns {Element[]} An array of DOM elements that are the next siblings of the given element.
 */
function nextSiblings(el) {
    let siblings = [];
    let nextEl = el ? el.nextElementSibling : null;

    while (nextEl) {
        siblings.push(nextEl);
        nextEl = nextEl.nextElementSibling;
    }

    return siblings;
}

/**
 * Gets all previous siblings of a given DOM element.
 *
 * @param {Element} el - The DOM element to find the previous siblings of.
 * @returns {Element[]} An array of DOM elements that are the previous siblings of the given element.
 */
function prevSiblings(el) {
    let siblings = [];
    let prevEl = el ? el.previousElementSibling : null;

    while (prevEl) {
        siblings.push(prevEl);
        prevEl = prevEl.previousElementSibling;
    }

    return siblings;
}

/**
 * Creates a CoverFlow effect for a carousel by manipulating the tilt and scale
 * of the carousel elements based on their position relative to the current element.

 * @param {Object} GlideCarousel - The carousel instance managing the slides.
 * @param {Object} Components - The components related to the carousel.
 * @param {Object} Events - The event handling system for the carousel.
 * @returns {Object} An object representing the `COVERFLOW` effect with tilt methods.
 */
function CoverFlow(GlideCarousel, Components, Events) {

    const ELEMENT_SELECTOR = '.brand-gallery-carousel-card';

    const COVERFLOW = {
        tilt(current) {
            const element = current.querySelector(ELEMENT_SELECTOR);
            if (element) {
                element.style.transform = `scale(1)`;
            }

            this.tiltPrevElements(current)
            this.tiltNextElements(current)
        },

        tiltPrevElements(current) {
            let prev = prevSiblings(current)

            for (let i = 0; i < prev.length; i++) {
                let el = prev[i].querySelector(ELEMENT_SELECTOR)

                el.style.transform = `scale(.85)`;
                el.style.transformOrigin = '100% 50%';
            }
        },

        tiltNextElements(current) {
            let next = nextSiblings(current)
            if (isIpad()) {
                for (let i = 0; i < next.length; i++) {
                    let el = next[i].querySelector(ELEMENT_SELECTOR)

                    el.style.transform = `scale(.85)`
                    el.style.transformOrigin = '0% 50%';
                }
            }
        }
    }

    Events.on(['mount.after', 'run'], () => {
        COVERFLOW.tilt(Components.Html.slides[GlideCarousel.index])
    })

    return COVERFLOW
}

/**
 * Initialize carousel
 * @param {jQuery} $containerEl the wrapper element
 */
function initializeCarousel($containerEl) {
    const $carousel = $($containerEl);
    const $carouselItems = $($carousel).find('.glide__slide').not('.glide__slide--clone');
    const $controls = $($carousel).find('[data-glide-el="controls"]');
    const totalSlides = $carouselItems.length;
    const $carouselEffect = $($containerEl).data('glide-effect');
    const peekValue = $carouselEffect === 'slide' ? 160 : 260;
    let glide;
    const defaults = {
        type: 'slider',
        perView: 1,
        rewind: false,
        gap: 24,
        peek: peekValue,
        breakpoints: {
            1199: {
                rewind: true,
                gap: 16,
                peek: 80
            },
            767: {
                rewind: true,
                gap: 0,
                peek: 0
            }
        }
    };

    const handleUpdateEvent = () => {
        if (!glide) { return; }
        const { perView } = glide.settings;
        if (totalSlides <= perView) {
            $controls.addClass('d-none');
            $($carousel).find('.glide__controls').removeClass('d-flex').addClass('d-none');
            $($carousel).closest('.content-carousel-container').removeClass('active-slider');
        } else {
            $controls.removeClass('d-none');
            $($carousel).find('.glide__controls').removeClass('d-none').addClass('d-flex');
            $($carousel).closest('.content-carousel-container').addClass('active-slider');
        }
        setTimeout(() => { $($carousel).addClass('glide--animated') }, 300);
    }

    glide = new Glide($carousel.get(0), defaults)
        .on('build.before', handleUpdateEvent)
        .mount({
            Controls,
            Breakpoints,
            Images,
            Swipe,
            Keyboard,
            ...($carouselEffect === 'cover-flow' && { CoverFlow }),
        });

    handleUpdateEvent()
}

$(document).ready(function () {
    $('.js-brand-carousel').each(function () {
        if ($(this).find('.alt-gallery-carousel-card').length && !$(this).find('.brand-carousel-card').length && !$(this).find('.gallery-carousel-card').length) {
            $(this).addClass('alt-gallery-carousel-layout');
        }

        createControls(this);
        initializeCarousel(this);
    });
});
